/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import SignupAvatarSectionDumb from './SignupAvatarSectionDumb';
import { getSelf } from 'src/shared/domain/user/selector/userSelectors';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  handleSubmit: () => void,
  handleBack: () => void,
};

const mapStateToProps = (
  state: State,
  { handleSubmit, handleBack }: Props,
): Object => ({
  handleSubmit,
  handleBack,
  user: getSelf(state),
});

export default compose(connect(mapStateToProps))(SignupAvatarSectionDumb);
